module.exports = __webpack_public_path__ + "img/16.e119b0f0.png";